import axiosInstance from './axiosInstance';

export const getFamilyMemberDetails = async customerCode => {
  try {
    const res = await axiosInstance.get(`/familymembers/customers/${customerCode}`, {
      data: null,
    });
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
